(function() {
    'use strict';


    angular.module('eclipseApp.myAccount').controller('lostStolenReactivateCtrl', ['$scope', '$state', 'httpService', 'lostStolenDeviceService', '$rootScope', 'commonService', 'uteLocale', function($scope, $state, httpService, lostStolenDeviceService, $rootScope, commonService, uteLocale) {


        $scope.backToAccount = function() {
            $state.go("myAccount.overview");
        }

        $scope.cancel = function() {
            angular.forEach(commonService.accountDetails, function(accountDetail, value) {
                if ($scope.ban === accountDetail.accountNumber) {
                    var lob = accountDetail.LOB;
                    if (lob.toUpperCase() == "WL") {
                        $state.go('myAccount.wireless', {
                            'accountNumber': $scope.ban,
                            'subscriberNo': $scope.ctn
                        });
                    } else {
                        $state.go('myAccount.prepaidWLDashboard', {
                            'accountNumber': $scope.ban,
                            'subscriberNo': $scope.ctn
                        });
                    }
                }
            });
        }


        $scope.init = function() {
            $scope.ctn = lostStolenDeviceService.getReactivateNumber();
            $scope.ban = lostStolenDeviceService.getAccountNumber();
            angular.forEach(commonService.accountDetails, function(accountDetail, accountDetailKey) {
                if ($scope.ban === accountDetail.accountNumber) {
                    angular.forEach(accountDetail.subscriberServices, function(subscriberService) {
                        if (subscriberService.wireless.subscriberNo == $scope.ctn) {
                            $scope.firstName = subscriberService.wireless.firstName ;
                            $scope.lastName = subscriberService.wireless.lastName ;
                        }
                    });
                }
            });
            if (uteLocale.language === 'en') {
                $scope.deviceDetail = lostStolenDeviceService.getDeviceDetails().en;
            } else {
                $scope.deviceDetail = lostStolenDeviceService.getDeviceDetails().fr;
            }
            console.log($scope.deviceDetail);
        }

        $scope.reactivate = function() {

            $scope.reactivateProcessing = true;
            var promise = httpService.send(

                'v1/wireless/lostorstolen/remove', {
                     accountNumber: $scope.ban,
                     ctn: $scope.ctn,
                     accountType: $rootScope.userInfo.profileType.prepaid ? 'prepaid' : 'postpaid' ,
                     customerFirstName: $scope.firstName ,
                     customerLastName: $scope.lastName ,
                     email: lostStolenDeviceService.getContactEmail(),
                     language: uteLocale.language
                });

            promise.then(
                function(result) {
                    if (result.data.error || result.data.status == 'Failed') {
                        $scope.reactivateProcessing = false;
                        $scope.losReactivateError = true;
                    } else {
                        angular.forEach(commonService.accountDetails, function(accountDetail, accountDetailKey) {
                            if ($scope.ban === accountDetail.accountNumber) {
                                angular.forEach(accountDetail.subscriberServices, function(subscriberService) {
                                    if (subscriberService.wireless.subscriberNo == $scope.ctn) {
                                        subscriberService.wireless.subscriberStatus = "Active";
                                        subscriberService.wireless.reason = null;
                                    }
                                });
                            }
                        });
                        $state.go("myAccount.lostStolenReactivateDeviceSuccess");
                    }
                },
                function(reason) {
                    $scope.reactivateProcessing = false;
                    $scope.losReactivateError = true;
                }
            );

        }

        $scope.init();
    }]);
})();
